import { render, staticRenderFns } from "./ModalEditarOpcoesEnquete.vue?vue&type=template&id=4a31d817&scoped=true"
import script from "./ModalEditarOpcoesEnquete.vue?vue&type=script&lang=js"
export * from "./ModalEditarOpcoesEnquete.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarOpcoesEnquete.vue?vue&type=style&index=0&id=4a31d817&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a31d817",
  null
  
)

export default component.exports